import React, { Component } from 'react';
import ChatBot from 'react-simple-chatbot';
import { ThemeProvider } from 'styled-components';
import questions from '../constants/coronaQuestion';
import Header from '../constants/Header';
import HeaderTitle from '../constants/HeaderTitle';
import { isMobile, isAndroid, isIOS } from 'react-device-detect';

const steps = questions;

const theme = {
  background: '#f5f8fb',
  fontFamily: 'Helvetica Neue',
  headerBgColor: '#ffffff',
  headerFontColor: '#000000',
  headerFontSize: '15px',
  botBubbleColor: '#f0f5ff',
  botFontColor: '#000000',
  userBubbleColor: '#00b73b',
  userFontColor: '#ffffff',
  borderRadius: '40px',
  fontWeight: '600',
};

class CoronaChatBot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileView: ''
    };
  }

  renderContent = () => {
    if (isMobile && isAndroid) {
      return '80vh';
    }
    if (isMobile && isIOS) {
      return '77vh';
    }
    else{
      return '';
    }
  }

  getStyleCss = () => {
    if (!isMobile) {
      return {
        margin: 'auto',
        display: 'block',
        paddingTop: '131px'
        //width: '100%'
      };
    }
    else{
      return {
        margin: 'auto'
      };
    }
  }

  getPositionCss = () => {
    if (!isMobile) {
      return 'relative';
    }
    else{
      return 'absolute';
    }
  }

  componentDidMount(){
    localStorage.clear();
  }

  render() {
    return (
      <div style={this.getStyleCss()}>
        <ThemeProvider theme={theme}>
        <ChatBot
          style={{position: 'fixed', marginLeft: '580px'}}
          steps={steps}
          contentStyle={
            { borderRadius: '20px', height : this.renderContent()}
          }
          bubbleStyle={{ fontWeight: '600' }}
          customStyle={{ background: '#f5f8fb', boxShadow: "none"}}
          hideBotAvatar={true}
          headerComponent={
            <Header className="rsc-header">
              <img alt="DocsApp" src="https://da-img.s3.amazonaws.com/corona_docsapp.svg" style={{ width: "110px", float: "left", paddingLeft:"16px" }} />
              <img alt="DocsApp" src="https://da-img.s3.amazonaws.com/corona_bot.svg" style={{ width: "90px", float: "right", paddingLeft:"62px" }} />
              <HeaderTitle className="rsc-header-title" style={{ marginRight: "5%" }}>Coronavirus Risk Scan</HeaderTitle>
            </Header>
          }
          hideUserAvatar={true}
          footerStyle={
            { display: "none"  
            }
          }
        />
      </ThemeProvider>
      </div>
    );
  }
}

export default CoronaChatBot;